import { createStore } from 'vuex'
import { state, mutations, actions, getters } from './store'

const store = createStore({
  state,
  mutations,
  actions,
  getters,
})

export default store

